import { Box, Image, Input, Link } from "components/base";
import { Container, ContainerFluid, Flex } from "components/base/container";
import { DiscordIcon, SearchIcon, TelegramIcon, TwitterIcon } from "components/icon/icon.normal";
import { useLocation, useNavigate } from "react-router-dom";
import {useWallet} from "@manahippo/aptos-wallet-adapter";
import {address_slice} from "../../utils";

const LayoutHeader = () => {
  const { disconnect, connect, connected,account, select, signAndSubmitTransaction, wallet } = useWallet();

  const navigate = useNavigate();
  const location = useLocation();
  return (
    <ContainerFluid bg={"black"}>
      <Container justifyContent={"space-between"} alignItems={"center"} py={"15px"}>
        <Link gridGap={"8px"} onClick={() => navigate("/")}>
          <Image src={require("assets/image/logo.png")} width={"42px"} />
          <Image src={require("assets/image/logo_title.svg").default} width={"100px"} />
        </Link>
        <Flex alignCenter fontSize={["24px", "26px", "28px", "30px"]} color={"light"} gridGap={"12px"}>
          {!connected &&
          <Link
              alignItems={"center"}
              bg={"#F2C65B"}
              p={"8px 16px"}
              borderRadius={"6px"}
              color={"bg"}
              fontWeight={"400"}
              fontSize={"18px"}
              lineHeight={"100%"}
              textTransform={"uppercase"}
              onClick={() => navigate("/wallet_connect")}
          >
            Connect Wallet
          </Link>
          }
          {connected &&
          <Link
              alignItems={"center"}
              bg={"#F2C65B"}
              p={"8px 16px"}
              borderRadius={"6px"}
              color={"bg"}
              fontWeight={"400"}
              fontSize={"18px"}
              lineHeight={"100%"}
              textTransform={"uppercase"}
              onClick={async () => await disconnect()}
          >
            { address_slice(account?.address as string)}
          </Link>
          }

          {/* <Link
              alignItems={"center"}
              pl={"16px"}
              color={"white"}
              fontWeight={"400"}
              fontSize={"18px"}
              lineHeight={"100%"}
              textTransform={"uppercase"}
              onClick={() => navigate("/wallet_connect")}
            >
              <Image src={require("assets/image/avatar.png")} transform={"translateX(-50%)"} width={"32px"} aspectRatio={"1"} borderRadius={"100%"} />
              <Flex ml={"-32px"} bg={"bg"} p={"8px 16px"} pl={"32px"} borderRadius={"0px 6px 6px 0px"}>
                User Name
              </Flex>
            </Link> */}
        </Flex>
      </Container>
    </ContainerFluid>
  );
};

export default LayoutHeader;
